export enum TocResourceState {
    Active = 'active',
    Inactive = 'inactive',
    OptionalAndActive = 'optional-and-active',
}
